import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { Info, CheckCircle2, AlertTriangle, Siren, X } from "lucide-react";

const STYLES = {
  info: { bg: "bg-blue-600", icon: Info },
  success: { bg: "bg-brand-emerald", icon: CheckCircle2 },
  warning: { bg: "bg-amber-500", icon: AlertTriangle },
  urgent: { bg: "bg-red-600", icon: Siren },
};

export default function BannerBar() {
  const location = useLocation();
  const [banners, setBanners] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem("mp_dismissed_banners") || "[]"); } catch (e) { return []; }
  });

  const load = async () => {
    try {
      const location = localStorage.getItem("mp_area") || "";
      const { data } = await api.get("/banners", { params: location ? { location } : {} });
      setBanners(data.banners);
    } catch (e) { console.debug("banner load failed", e); }
  };

  useEffect(() => {
    load();
    const iv = setInterval(load, 30000);
    return () => clearInterval(iv);
    // eslint-disable-next-line
  }, [location.pathname, location.search]);

  const dismiss = (id) => {
    const next = [...dismissed, id];
    setDismissed(next);
    sessionStorage.setItem("mp_dismissed_banners", JSON.stringify(next));
  };

  const visible = banners.filter((b) => !dismissed.includes(b.id));
  if (visible.length === 0) return null;

  return (
    <div data-testid="banner-stack">
      {visible.map((b) => {
        const s = STYLES[b.style] || STYLES.info;
        const Icon = s.icon;
        return (
          <div key={b.id} className={`${s.bg} text-white`} data-testid={`banner-${b.id}`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-8 py-2.5 flex items-center gap-3 text-sm">
              <Icon className="w-4 h-4 shrink-0" />
              <p className="flex-1 font-medium leading-snug">
                {b.message}
                {b.link && <a href={b.link} target="_blank" rel="noopener noreferrer" className="underline font-semibold ml-2 whitespace-nowrap" data-testid={`banner-link-${b.id}`}>Learn more →</a>}
              </p>
              <button onClick={() => dismiss(b.id)} data-testid={`banner-dismiss-${b.id}`} className="shrink-0 opacity-80 hover:opacity-100"><X className="w-4 h-4" /></button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
